import { JFSRequest, executeRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  console.log('response', response)
  const data = isSuccessResponse(response)
  return data
}

export const getJobIdForExportApi = (body: string, abortController?: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getJobIdForExportApi),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens, abortController),
    headers: getHeaders(),
    body,
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export const getExportByJobIdProgressApi = (jobId: string, abortController?: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getExportByJobIdStatus),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens, abortController),
    headers: getHeaders(),
    body: { jobId },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export const downloadFileUsingJobId = (jobId: string, abortController?: any) => {
  const request: JFSRequest<{}> = {
    apiPath: `${getUrl(APIEndPoints.downloadFileUsingJobId)}/${jobId}`,
    method: 'POST',
    responseType: 'arraybuffer',
    config: sitConfig(RootStore.session.getTokens, abortController),
    headers: getHeaders(),
  }

  return executeRequest(request).catch((error) => {
    if (error?.message?.includes('File not found for jobId')) {
      error.data.error.message = 'No records found for the selected filter'
      error.message = 'No records found for the selected filter'
    }
    throw error
  })
}
